import { render, staticRenderFns } from "./ShweList.vue?vue&type=template&id=5fb79308&scoped=true&"
import script from "./ShweList.vue?vue&type=script&lang=js&"
export * from "./ShweList.vue?vue&type=script&lang=js&"
import style0 from "./ShweList.vue?vue&type=style&index=0&id=5fb79308&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb79308",
  null
  
)

export default component.exports